module.exports = __webpack_public_path__ + "static/ACTIVE_tabletennis_1987.f520d7c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/ACTIVE_tabletennis_1987.jpg
// module id = 493
// module chunks = 8418805283199